export const RELOAD_TIME_MS = 60 * 1000;
